import { FC } from 'react'
import './group-progress-bar.css'

// COMPONENTS
import { GeneralProgressBar } from '@components/atoms/progressbar/general-progress-bar'

// UTILITIES
import { priceFormatter, toPennies } from '@utils/number-helper'


interface Props {
    goal: number
    pledge: number
}

const GroupProgressBar: FC<Props> = ({ goal, pledge }) => {
    const remaining = Math.max(0, goal - toPennies(pledge))

    if (goal === 0) return null
    else return (
        <div className="group-progress-bar">
            <div className="top-row">
                <div className='flex flex-col gap-2'>
                    <p className='text-body-2 text-blue-200'><strong>GOAL: {priceFormatter.format(goal / 100)}</strong></p>
                    <h1>{priceFormatter.format(pledge)}</h1>
                </div>
                <div className='flex flex-col gap-2 text-right'>
                    <p className='text-body-2 text-blue-200'>Remaining</p>
                    <h2 className="text-blue-200" style={{ fontWeight: '400' }}>{priceFormatter.format(remaining / 100)}</h2>
                </div>
            </div>

            <div className="progress-bar-container">
                <GeneralProgressBar
                    value={toPennies(pledge)}
                    max={goal}
                    settings={{
                        trackColor: 'var(--splitcard-gray-700)',
                        fillColor: 'var(--splitcard-blue-500)',
                        useThumb: false
                    }}
                    style={{ height: '100%', borderRadius: 'var(--border-radius-circle)' }}
                />
            </div>
        </div>
    )
}

export default GroupProgressBar
